import envVariables from "../data/envVariables";

/**
 * @param {string} url - URL or path to check
 * @returns {boolean}
 */
export const isInternalUrl = (url) => {
    return url.indexOf("/") === 0;
};

/**
 * @param {Object} poweredByCtx - Powered-by context (isPoweredBy, tenantUrl)
 * @param {string} pathname - Path (e.g. "/page")
 * @returns {string} Full URL without trailing slash
 */
export const getUrl = (poweredByCtx, pathname) => {
    let url = `https://www.shyaviation.com${pathname}`;

    if (poweredByCtx.isPoweredBy) {
        url = `https://${poweredByCtx.tenantUrl}${pathname}`;
    }

    return url.replace(/\/$/, "");
};

/**
 * Get the document base URL based on tenant ID
 * For JetSphere clients (when tenantID exists), returns the tenant's domain
 * Otherwise, returns the default SHY document base
 * @param {string} tenantID - The tenant ID from the deal
 * @param {object} poweredByCtx - The PoweredByContext (optional)
 * @returns {string} The document base URL
 */
export const getDocumentBaseUrl = (tenantID, poweredByCtx = null) => {
    // If no tenantID or empty, use default SHY domain
    if (!tenantID || tenantID === "") {
        return envVariables.documentBase;
    }

    // If we have PoweredByContext and it's a powered by client, use tenant URL
    if (poweredByCtx && poweredByCtx.isPoweredBy && poweredByCtx.tenantUrl) {
        return `https://${poweredByCtx.tenantUrl}`;
    }

    // For JetSphere clients, try to look up tenant domain from tenant ID
    if (poweredByCtx && poweredByCtx.getTenantUrlFromId && poweredByCtx.domainsAndTenants) {
        const tenantUrl = poweredByCtx.getTenantUrlFromId(tenantID);
        if (tenantUrl) {
            return `https://${tenantUrl}`;
        }
    }

    // For JetSphere clients, if tenantID looks like a domain, use it directly
    if (tenantID.includes(".")) {
        return `https://${tenantID}`;
    }

    // Otherwise, use default SHY domain
    // Note: If tenant domain lookup is needed, it should be done via API call
    // For now, we'll use the default domain if we can't determine the tenant domain
    return envVariables.documentBase;
};
